<template>
  <div>
    <a-card size="small">
      <a-page-header :loading="loading" :sub-title="`#${artifactData.id}`" :title="artifactData.name" @back="() => $router.go(-1)">
        <div class="content">
          <div class="main">
            <a-descriptions size="small" :column="2">
              <a-descriptions-item label="仓库分类"> {{ artifactData.category }} </a-descriptions-item>
              <a-descriptions-item label="仓库地址"> {{ artifactData.registry_url }} </a-descriptions-item>
              <a-descriptions-item label="仓库描述"> {{ artifactData.description }} </a-descriptions-item>
            </a-descriptions>
          </div>
        </div>
        <template slot="footer">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="版本列表">
              <artifact-version />
            </a-tab-pane>
          </a-tabs>
        </template>
      </a-page-header>
    </a-card>
  </div>
</template>
<script>
import { artifactDetail } from '@/api/system/artifact';
import ArtifactVersion from '@/pages/project/service/components/ArtifactVersion';

export default {
  components: { ArtifactVersion },
  data() {
    return {
      loading: false,
      detailLoading: false,
      artifactId: this.$route.query.artifactId || null,

      artifactData: {}
    };
  },
  created() {
    this.getArtifactDetail();
  },
  methods: {
    getArtifactDetail() {
      this.detailLoading = true;
      artifactDetail({ artifact_id: this.artifactId }).then(res => {
        this.artifactData = res.data;
        this.detailLoading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-page-header) {
  padding: 0px;
}

.creator-nickname {
  margin-left: 4px;
  line-height: 32px;
}
:deep(.ant-descriptions-item > span) {
  display: inline-table;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}
</style>
